export default "__VITE_ASSET__CpxjuHr8__"